// import { readJson } from '../../services/fileOps'
// import Marker from './marker'
import {BasicManagedFile, tryGetAttr} from './basicManagedFile'


export default class Schema extends BasicManagedFile {


  constructor(args){
    super(args)
    this.ext = Schema.getExt()
  }

  getSchema(){
    return this.content.getData(true, 0).schema
  }

  static getExt(){
    return 'schema.json'
  }

  static tryGetAttr(attr, cb){
    return tryGetAttr(attr, cb)
  }


}
